/**
 * Evaluates the given redirects. The given redirects are evaluated in order, and the
 * first one to return a redirect path will be returned.
 * 
 * @param { string | function | ( string | function )[] } redirects - The redirects to evaluate.
 * @param { any[] } funcArgs
 * @returns { string | undefined }
 */
function evaluateRouteRedirect( redirects, funcArgs = [] ) {
    if ( !redirects ) {
        return undefined;
    }

    const redirectsList = Array.isArray( redirects ) ? redirects : [ redirects ];
    for ( let i = 0; i < redirectsList.length; i++ ) {
        const redirectOption = redirectsList[ i ];
        const redirectType = ( typeof redirectOption );
        
        // Attempt to determine where to redirect the user if needed.
        let result = undefined;
        switch ( redirectType ) {
            case 'function':
                result = evaluateRouteRedirect( redirectOption( ...funcArgs ) );
                break;

            case 'string':
                result = redirectOption;
                break;

            default:
                // Do nothing with unrecognized type...
                break;
        }

        // If there is a resulting redirect path, return it.
        if ( result ) {
            return result;
        }
    }

    // Return `undefined` to suggest that the user doesn't need to be redirected.
    return undefined;
}

export default evaluateRouteRedirect;
